export default function SupportBadge({ text = 'Support' }: { text?: string }) {
  return (
    <span className="relative bg-neutral-100 px-[0.1875rem] font-medium text-[0.625rem]/[0.875rem] text-neutral-500 dark:bg-neutral-800 dark:text-neutral-400">
      {text}
      <span className="-top-px absolute inset-x-[-0.1875rem] block transform-gpu text-neutral-300 dark:text-neutral-700">
        <svg aria-hidden="true" height="1" stroke="currentColor" strokeDasharray="3.3 1" width="100%">
          <line x1="0" x2="100%" y1="0.5" y2="0.5" />
        </svg>
      </span>
      <span className="-bottom-px absolute inset-x-[-0.1875rem] block transform-gpu text-neutral-300 dark:text-neutral-700">
        <svg aria-hidden="true" height="1" stroke="currentColor" strokeDasharray="3.3 1" width="100%">
          <line x1="0" x2="100%" y1="0.5" y2="0.5" />
        </svg>
      </span>
      <span className="-left-px absolute inset-y-[-0.1875rem] block transform-gpu text-neutral-300 dark:text-neutral-700">
        <svg aria-hidden="true" height="100%" stroke="currentColor" strokeDasharray="3.3 1" width="1">
          <line x1="0.5" x2="0.5" y1="0" y2="100%" />
        </svg>
      </span>
      <span className="-right-px absolute inset-y-[-0.1875rem] block transform-gpu text-neutral-300 dark:text-neutral-700">
        <svg aria-hidden="true" height="100%" stroke="currentColor" strokeDasharray="3.3 1" width="1">
          <line x1="0.5" x2="0.5" y1="0" y2="100%" />
        </svg>
      </span>
    </span>
  );
}
